import React from "react";
import styled from "styled-components";
import ClickOutside from "react-click-outside";
import * as R from "ramda";
import { withState } from "recompose";
import { colors } from "core/stylesheet";
import { Checkbox, Input } from "components/generic/form/native";
import caret from "../assets/caret-right.svg";

export default withState("isOpen", "setOpenList", false)(
  ({
    selected,
    title,
    all_items_label,
    items,
    isOpen,
    field,
    onFilterChange,
    more,
    setOpenList
  }) => (
    <div className="relative">
      <InputWrap>
        <Input
          placeholder={title}
          className="dd-header"
          arrowIcon
          onClick={() => setOpenList(!isOpen)}
        />
      </InputWrap>
      {isOpen && (
        <ClickOutside onClickOutside={() => setOpenList(false)}>
          <Wrap>
            <MobileWrap>
              <Pane className="pa3 relative" onClick={() => setOpenList(false)}>
                <Caret src={caret} alt="" />
                {title}
              </Pane>
            </MobileWrap>
            {items.map((item, i) => (
              <Option
                selected={selected}
                item={item}
                field={field}
                onFilterChange={onFilterChange}
                key={i}
              />
            ))}
            {more}
          </Wrap>
        </ClickOutside>
      )}
      {/* {isOpen && all_items_label && <div>{all_items_label}</div>} */}
    </div>
  )
);

const Option = withState("isOpen", "setOpenList", false)(
  ({ selected, item, field, isOpen, setOpenList, onFilterChange }) => (
    <React.Fragment>
      <OptionContainer hasDropdown={field === "company"} isOpened={isOpen}>
        <div
          className="pa3 flex items-center"
          onClick={() => {
            if (field === "company") {
              setOpenList(!isOpen);
            } else {
              onFilterChange({
                ...item,
                field
              });
            }
          }}
        >
          <Check
            checked={(selected && selected.includes(item.value)) || false}
            title={item.value}
            onClick={e => {
              e.stopPropagation();
              onFilterChange({
                ...item,
                field
              });
            }}
          />
          {item.label}
        </div>
      </OptionContainer>
      {isOpen &&
        field === "company" && (
          <div className="bg-white pl3">
            {R.values(item.sub_items)[0].map((title, i) => (
              <Checkbox
                checked={(selected && selected.includes(title)) || false}
                title={title}
                onChange={() => {
                  onFilterChange({
                    value: title,
                    field
                  });
                }}
              >
                {title}
              </Checkbox>
            ))}
          </div>
        )}
    </React.Fragment>
  )
);

const Caret = styled.img`
  position: absolute;
  left: 1rem;
  top: calc(1rem + 3px);
  transform: scaleX(-1);
`;

const MobileWrap = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const InputWrap = styled.div`
  @media (max-width: 768px) {
    input {
      background-color: #fff;
      color: #333333;
      border: 0;
      background: #fff url(${caret}) 95% 15px;
      background-repeat: no-repeat;
    }
  }
`;

const Pane = styled.div`
  font-family: CircularStd-Book;
  background-color: #fff;
  text-align: center;
  border-bottom: 1px solid #e6e5e0;
`;

const Wrap = styled.div`
  box-shadow: 0px 4px 6px #979797;
  position: absolute;
  left: 0;
  top: 3rem;
  width: 100%;
  background-color: rgba(248, 247, 245, 1);
  @media (max-width: 768px) {
    overflow-y: auto;
    box-shadow: none;
    position: fixed;
    top: 0;
    z-index: 1;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;

const OptionContainer = styled.li`
  background-color: rgba(248, 247, 245, 1);
  list-style-type: none;
  border-bottom: 1px solid #e6e5e0;
  ${({ hasDropdown }) =>
    hasDropdown &&
    `
    position: relative;
    &:after {
      content: "";
      position: absolute;
      right: 1rem;
      top: 0;
      bottom: 0;
      margin: auto;
      background-image: url(${caret});
      width: 11px;
      height: 18px;
    }
  `} ${({ isOpened }) =>
      isOpened &&
      `
      &:after {
        transform: rotate(90deg);
      }
  `} &:hover {
    background-color: #ebe8e1;
  }
  @media (max-width: 768px) {
    background-color: #fff;
  }
`;

const Check = styled.input.attrs({
  className: "br1 pointer",
  type: "checkbox"
})`
  appearance: none;
  outline: none;
  width: 18px;
  height: 18px;
  border: 1px solid #aaa;
  margin-right: 10px;
  position: relative;
  flex-shrink: 0;
  &:checked:before {
    content: "✔";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.brand};
    font-family: "CircularStd-Book";
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/Filter.js